import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../../utils/withRouter";
import { ToastContainer } from "react-toastify";
import StaticFooter from "../../common_components/StaticFooter";
import StaticHeader from "../../common_components/staticHeader";
import { getCurrentAwardDetails_action } from '../../../../actions/static_action/currentAwardDetails_action'
import $ from 'jquery'
import { toastError } from "../../../../utils/constants";
import Loader from "../../../../utils/Loader";
import { ItemElement } from "@hilla/react-components/Item.js";
import moment from "moment";
import Carousel from "../../common_components/carousel";
import { Modal } from "react-bootstrap";
import purify from 'dompurify'
import { getCmsContent_action } from "../../../../actions/cms_action/cmsAction";

class Category extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIndex: 0,
            awardCarouselList: [],
            awardDetailsList: [],
            isAllCategory: false,
            isLoading: false,
            award_event_profile_id: '',
            award_event_id: '',
            applicantPricingList: [],
            isCheckedErr: '',
            isOpen2: false,
            LaunchDate: null,
            isCommingSoon: false,
            timeLeft: {},
            intervalId: null,
            cmsSectionData: [],
            cmsMenuData: [],
            cmsFooterData: [],
            awardType: '',
        };
        this.slidesToShow = 5;
        this.slideInterval = 3000;
    }


    componentDidMount() {
        this.startAutoSlide();
        const uid = this.props.location.search != '' ? this.props.location.search.split('&')[0].split('=')[1] : null
        this.setState({
            isAllCategory: uid ? true : false,
            award_event_profile_uid: uid
        }, () => {
            this.getCurrentAwardDetails('', uid)
        })
        this.loadscript()
        console.log("this.props", this.props)
        this.getCmsContent(4)
    }

    loadscript() {
        $(document).ready(function () {
            $(this).scrollTop(0);
        });
    }

    componentWillUnmount() {
        clearInterval(this.autoSlideInterval);
        clearInterval(this.timer);
    }
    async getCmsContent(MenuID) {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(MenuID ? MenuID : 1);

            if (data.error !== 1) {
                this.setState({
                    isLoading: false,
                    cmsSectionData: data?.data[0] !== "" ? data?.data[0] : [],
                    cmsMenuData: data?.data[1] !== "" ? data?.data[1] : [],
                    cmsFooterData: data?.data[2][0] !== "" ? data?.data[2][0] : [],
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    getCountDownDate() {
        this.setState({ isLoading: true })
        this.props.getCurrentAwardDetails_action(null)
            .then((data) => {
                if (data.error != 1) {
                    if (data.applicationDate != '') {

                        const LaunchDate = data.applicationDate[0]["launch_date"]
                        this.setState({ LaunchDate: LaunchDate })
                        const targetDate = moment.utc(LaunchDate);  // Target in UTC

                        // Current date in UTC
                        const currentDate = moment();  // Current date in UTC
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        if (totalSeconds >= 0) {
                            const timer = setInterval(() => {
                                this.setState({ timeLeft: this.calculateTimeLeft(LaunchDate) }, () => {
                                    this.setState({ isOpen2: true, isLoading: false, isCommingSoon: false });
                                });
                            }, 1000);
                            this.setState({ intervalId: timer });
                        } else {
                            this.setState({ isCommingSoon: true, isLoading: false }, () => {
                                const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
                                if (userLoginData != null) {
                                    this.props.navigate('/applicationForm')
                                } else {
                                    this.props.navigate('/login')
                                }
                            });
                        }
                    } else {
                        this.setState({ isCommingSoon: true })
                        const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
                        if (userLoginData != null) {
                            this.props.navigate('/applicationForm')
                        } else {
                            this.props.navigate('/signUp')
                        }
                    }

                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    calculateTimeLeft = (LaunchDate) => {

        const targetDate = moment.utc(LaunchDate);  // Target in UTC
        // console.log("Target Date in UTC: ", targetDate.format()); 

        // Current date in UTC
        const currentDate = moment();  // Current date in UTC
        // console.log("Current Date in UTC: ", currentDate.format().split('+'));
        const split = currentDate.format().split('+')
        const updateCurrentDate = split[0] + 'Z'
        // console.log("Current Date in UTC: ", updateCurrentDate);

        // Calculate the difference between the current time and target time in total seconds
        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');

        console.log("totalSeconds--------->", totalSeconds)
        // Calculate the total minutes, hours, and days
        const days = Math.floor(totalSeconds / (60 * 60 * 24)); // Convert seconds to days
        const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60)); // Convert remainder to hours
        const minutes = Math.floor((totalSeconds % (60 * 60)) / 60); // Convert remainder to minutes
        const seconds = totalSeconds % 60; // Remainder is the seconds

        // If the countdown reaches 0, close the modal and trigger 'handleRegisterNow'
        if (days == 0 && hours == 0 && minutes == 0 && seconds == 0) {
            this.setState({ isOpen2: false }, () => {
                const { intervalId } = this.state;
                if (intervalId) {
                    clearInterval(intervalId); // Stop the timer
                    this.setState({ intervalId: null }); // Reset the interval ID
                }
                this.props.navigate('/signUp')
            })
        }

        return {
            days: days < 10 ? `0${days}` : days,
            hours: hours < 10 ? `0${hours}` : hours,
            minutes: minutes < 10 ? `0${minutes}` : minutes,
            seconds: seconds < 10 ? `0${seconds}` : seconds,
        };
    };
    startAutoSlide = () => {
        this.autoSlideInterval = setInterval(() => {
            this.moveSlide(1);
        }, this.slideInterval);
    };

    moveSlide = (step) => {
        const { currentIndex, awardCarouselList } = this.state;
        const totalSlides = awardCarouselList.length;
        const newIndex = (currentIndex + step + totalSlides) % totalSlides;
        this.setState({ currentIndex: newIndex });
    };

    getCurrentAwardDetails(award_event_profile_id, param_uid) {
        this.setState({ isLoading: true })

        this.props.getCurrentAwardDetails_action(null, param_uid ? param_uid : null)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({
                        isLoading: false,
                        awardCarouselList: data.data,
                        awardDetailsList: data.data2,
                        applicantPricingList: data.applicantPricingList,
                        awardType: data.awardList?.[0]?.['country_type'],
                    })
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onAwardApply() {
        this.setState({ isAllCategory: false }, () => this.getCurrentAwardDetails(null, 2), this.loadscript())
    }

    onClickLoginSignUp(flag) {
        const { award_event_profile_id, isCommingSoon } = this.state
        if (flag) {
            sessionStorage.setItem("award_event_profile_id", award_event_profile_id)
            if (isCommingSoon) {
                const userLoginData = JSON.parse(sessionStorage.getItem("AwardsUserLoginData"));
                if (userLoginData != null) {
                    this.props.navigate('/applicationForm')
                } else {
                    this.props.navigate('/signUp')
                }
            } else {
                this.getCountDownDate()
            }
        } else {
            this.setState({ isCheckedErr: 'Please check the terms and conditions before clicking on "Apply."' })
            toastError('Please check the terms and conditions before clicking on "Apply."')
        }
    }

    handleCheckboxChange = (itemId, isChecked) => {
        const updatedList = this.state.awardDetailsList.map((item) =>
            item.award_event_profile_id === itemId
                ? { ...item, isChecked }
                : item
        );
        this.setState({ awardDetailsList: updatedList, isCheckedErr: '' });
    };

    renderButtonOrMessage = (item) => {
        const now = moment();
        const startDate = moment(item.application_start_date);
        const endDate = moment(item.application_to_date);

        if (endDate.isBefore(now, 'day') && !now.isSame(startDate, 'day')) {
            return (
                <div className="text-end">
                    <button
                        type="button"
                        className="btn btn-outline-primary mt-3 rounded-2 px-4 py-1"
                        disabled
                        title={`The deadline to fill out the form has passed on ${endDate.format('D MMM, YYYY')}`}
                    >
                        Apply
                    </button>
                    <span className="text-danger d-block mt-1">
                        The deadline to fill out the form has passed on {endDate.format('D MMM, YYYY')}
                    </span>
                </div>
            );
        }

        // if (startDate.isAfter(now)) {
        //     return (
        //         <div className="text-end">
        //             <label className="d-flex" style={{ cursor: 'pointer' }}>
        //                 <input
        //                     type="checkbox"
        //                     className="mr-2"
        //                     checked={item.isChecked}
        //                     onChange={(e) =>
        //                         this.handleCheckboxChange(item.award_event_profile_id, e.target.checked)
        //                     }
        //                 />
        //                 I acknowledge that I have read, understand, and agree to the terms and conditions.
        //             </label>
        //             <button
        //                 type="button"
        //                 className="btn btn-outline-primary mt-3 rounded-2 px-4 py-1"
        //                 disabled={!item.isChecked}
        //                 onClick={() =>
        //                     this.setState(
        //                         { award_event_profile_id: item.award_event_profile_id },
        //                         () => this.onClickLoginSignUp(false)
        //                     )
        //                 }
        //             >
        //                 Apply
        //             </button>
        //         </div>
        //     );
        // }

        return (
            <>
                <div className="d-flex justify-content-between align-items-end mt-4">
                    <div>
                        <label className="d-flex" style={{ cursor: 'pointer' }}>
                            <input
                                type="checkbox"
                                className="mr-2"
                                checked={item.isChecked}
                                onChange={(e) =>
                                    this.handleCheckboxChange(item.award_event_profile_id, e.target.checked)
                                }
                            />
                            I acknowledge that I have read, understand, and agree to the terms and conditions.
                        </label>
                        {this.state.isCheckedErr && (
                            <span className="text-danger d-block">{this.state.isCheckedErr}</span>
                        )}
                    </div>

                </div>


                <button
                    type="button"
                    className={`btn btn-success text-white rounded-2 px-5 py-1.5`} style={{ float: 'right' }}
                    // disabled={!item.isChecked}
                    onClick={() =>
                        this.setState(
                            { award_event_profile_id: item.award_event_profile_id },
                            () => this.onClickLoginSignUp(item.isChecked)
                        )
                    }
                >
                    Apply
                </button>

                <a target="_blank" href="https://awards.india-itme.com/static/images/Reg-form.mp4"
                    className={`btn btn-success text-white rounded-2 px-5 py-1.5 mx-2`} style={{ float: 'right' }}>
                    Demo Video
                </a>
            </>
        );
    };

   getOrdinal(day) {
    if (day > 3 && day < 21) return day + "th";
    switch (day % 10) {
      case 1: return day + "st";
      case 2: return day + "nd";
      case 3: return day + "rd";
      default: return day + "th";
    }
  }

 formatDate(dateString) {
  // REMOVE timezone effect by stripping 'Z'
  const cleanDateString = dateString.replace("Z", "");
  const date = new Date(cleanDateString);

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return day + "th";
    switch (day % 10) {
      case 1: return day + "st";
      case 2: return day + "nd";
      case 3: return day + "rd";
      default: return day + "th";
    }
  };

  const day = getOrdinal(date.getDate());
  const month = date.toLocaleString("en-GB", { month: "long" });
  const year = date.getFullYear();

  const time = date.toLocaleString("en-GB", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });

  return `${day} ${month} ${year} at ${time}`;
}
    render() {
        const { awardCarouselList, currentIndex, awardDetailsList, isAllCategory, isLoading, applicantPricingList, timeLeft, cmsSectionData, cmsMenuData, cmsFooterData, awardType, LaunchDate } = this.state;
        const totalSlides = awardCarouselList.length;

        const groupedByLabel = awardDetailsList.reduce((acc, item) => {
            const { section_label } = item;
            if (!acc[section_label]) {
                acc[section_label] = [];
            }
            acc[section_label].push(item);
            return acc;
        }, {});
        return (
            <>
                <StaticHeader headerNavs={cmsMenuData} />
                {isLoading ? <Loader></Loader> : null}
                <>
                    <div className="website">
                        <section className="banner page-banner position-relative pb-0">
                            <div className="overlay"></div>
                            <div className="container">
                                <div className="page-title text-center position-relative py-3 mt-2">
                                    {awardCarouselList.length > 0 ? <>
                                        <div className="row gy-5">
                                            <div className="col-lg-12">
                                                {awardCarouselList.length > 0 ? <Carousel state={{ awardCarouselList: awardCarouselList, screen: 'category' }} /> : <p>Record Not Found</p>}
                                            </div>
                                        </div>
                                    </> : <></>}
                                </div>
                            </div>
                        </section>
                        {awardCarouselList.length > 0 ? <>
                            <section className="speaker-detail" style={{ paddingTop: 20 }}>
                                <div className="container">
                                    <div className="popular-ques-left me-4 m-sm-0">
                                        <div className="faq-accordion p-4 bg-white rounded">
                                            {Object.keys(groupedByLabel).map((sectionLabel, index) => {
                                                const sectionItems = groupedByLabel[sectionLabel];

                                                return (
                                                    <div key={index}>
                                                        {/* Render section label once */}
                                                        <div
                                                            className="orange_strip"
                                                            style={{
                                                                padding: '11px 15px',
                                                                background: 'rgb(103 178 180)',
                                                                lineHeight: '1',
                                                                color: '#fff',
                                                                fontWeight: '600',
                                                                textAlign: 'left',
                                                                marginBottom: '10px',
                                                                position: 'relative',
                                                            }}
                                                        >
                                                            {sectionLabel}
                                                        </div>

                                                        {/* Render all award names under the same section */}
                                                        {sectionItems.map((item, i) => {
                                                            const filterPricingList = applicantPricingList.filter(
                                                                (data) => data.award_event_profile_id === item.award_event_profile_id
                                                            );
                                                            return (
                                                                <div key={i} className="accordion-item col-radius-top border-bottom border mb-4">
                                                                    <p className="accordion-header p-2 py-3 rounded-1 border-bottom">
                                                                        <button
                                                                            className={`accordion-button ${!isAllCategory ? "collapsed" : ""} p-0`}
                                                                            type="button"
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target={`#collapseOne${item.award_event_profile_id}_${i}`}
                                                                            aria-expanded="false"
                                                                            aria-controls={`flush-collapseOne${item.award_event_profile_id}_${i}`}
                                                                            style={{ fontWeight: 500 }}
                                                                        >
                                                                            {item.award_name}
                                                                        </button>
                                                                    </p>
                                                                    <div
                                                                        id={`collapseOne${item.award_event_profile_id}_${i}`}
                                                                        className={`accordion-collapse collapse ${isAllCategory ? "show" : ""}`}
                                                                    >
                                                                        <div className="accordion-body p-0">
                                                                            <div className="inner-speaker-detail text-center text-md-start">
                                                                                <div className="row gx-md-5 gy-5">
                                                                                    <div className="col-lg-12">
                                                                                        <div className="speaker-detail-right p-6 pb-3 pt-2" style={{ borderBottom: '1px solid #e0e3e7' }}>
                                                                                            <div className="col-md-3">
                                                                                                <div className="speaker-img">
                                                                                                    <img src="static/images/award3.png"
                                                                                                        alt="speaker" className="rounded-circle border border-4 border-lightgrey object-fit-cover" />
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="speaker-bio mb-4">
                                                                                                <p className="mb-1">
                                                                                                    For {filterPricingList.length > 0 &&
                                                                                                        filterPricingList.map((data, index) => (
                                                                                                            <span key={index}>{data.applicant_type} {filterPricingList.length !== (index + 1) ? ' / ' : ' '}</span>
                                                                                                        ))}
                                                                                                </p>
                                                                                            </div>
                                                                                            <div className="row pt-2 rounded-2 mt-1">
                                                                                                <div className="speaker-contact-info text-start">
                                                                                                    {item.theme && item.theme !== "<p><br></p>" ? <>
                                                                                                        <div className="contact-info-list d-flex align-items-center mb-4">
                                                                                                            <div className="contact-detail">
                                                                                                                <span className="fw-semibold black my-1 lh-base">Theme</span>
                                                                                                                <p className="m-1"><span dangerouslySetInnerHTML={{ __html: purify.sanitize(item.theme) }} /></p>
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </> : null}
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row pt-2 rounded-2 mt-1">
                                                                                                <div className="speaker-contact-info text-start">
                                                                                                    <div className="contact-info-list d-flex align-items-center mb-4">
                                                                                                        <div className="contact-detail">
                                                                                                            {item.eligibility_criteria && item.eligibility_criteria !== "<p><br></p>" ? <>
                                                                                                                <span className="fw-semibold black my-1 lh-base">Eligibility</span>
                                                                                                                <p className="m-1">
                                                                                                                    <span dangerouslySetInnerHTML={{ __html: purify.sanitize(item.eligibility_criteria) }} />
                                                                                                                </p>
                                                                                                            </> : null}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row rounded-2 mt-1">
                                                                                                <div className="speaker-contact-info text-start">
                                                                                                    <div className="contact-info-list d-flex align-items-center mb-4">
                                                                                                        <div className="contact-detail">
                                                                                                            {item.screening_process && item.screening_process !== "<p><br></p>" ? <>
                                                                                                                <span className="fw-semibold black my-1 lh-base">Screening process</span>
                                                                                                                <p className="m-1">
                                                                                                                    <span dangerouslySetInnerHTML={{ __html: purify.sanitize(item.screening_process) }} />
                                                                                                                </p>
                                                                                                            </> : null}
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div className="row mt-1">
                                                                                                <div className="card p-0">
                                                                                                    {item.important_instructions && item.important_instructions !== "<p><br></p>" ? <>
                                                                                                        <h5 className="card-header bg-warning text-white py-2" style={{ fontSize: 15 }}>Important instructions</h5>
                                                                                                        <div className="card-body p-0 pt-1">
                                                                                                            <p className="m-1"><span className="important-text" dangerouslySetInnerHTML={{ __html: purify.sanitize(item.important_instructions) }} /></p>
                                                                                                        </div>
                                                                                                    </> : null}
                                                                                                </div>
                                                                                                <table className="table table-bordered mt-4 mb-0" id="dashboard-table">
                                                                                                    <thead>
                                                                                                        <tr>
                                                                                                            <th>Applicant Fee's</th>
                                                                                                            {awardType == "National" ?
                                                                                                                <th className="text-right">Rate (INR)</th> :
                                                                                                                awardType == "International" ? <th className="text-right">Rate (USD)</th> :
                                                                                                                    <>
                                                                                                                        <th className="text-right">Rate (INR)</th>
                                                                                                                        <th className="text-right">Rate (USD)</th>
                                                                                                                    </>
                                                                                                            }
                                                                                                        </tr>
                                                                                                    </thead>
                                                                                                    <tbody>
                                                                                                        {applicantPricingList.length > 0 ? (
                                                                                                            applicantPricingList.map((data, index) => (
                                                                                                                data.award_event_profile_id === item.award_event_profile_id && (
                                                                                                                    <tr key={index}>
                                                                                                                        <td>{data.applicant_type}&nbsp;
                                                                                                                            {item.is_gst_applicable === 1 && (data.rate_inr !== 0 || data.rate_usd !== 0)
                                                                                                                                ? "(Incl. GST)" : data.rate_inr === 0 && data.rate_usd === 0 ? "(Free)" : ""}
                                                                                                                        </td>
                                                                                                                        {awardType == "National" ?
                                                                                                                            <td className="text-right">{data.rate_inr != null && (data.rate_inr).toLocaleString()}</td> :
                                                                                                                            awardType == "International" ?
                                                                                                                                <td className="text-right">{data.rate_usd != null && (data.rate_usd).toLocaleString()}</td> :
                                                                                                                                <>
                                                                                                                                    <td className="text-right">{data.rate_inr != null && (data.rate_inr).toLocaleString()}</td>
                                                                                                                                    <td className="text-right">{data.rate_usd != null && (data.rate_usd).toLocaleString()}</td>
                                                                                                                                </>
                                                                                                                        }
                                                                                                                    </tr>
                                                                                                                )
                                                                                                            ))
                                                                                                        ) : (
                                                                                                            <tr><td colSpan={3} style={{ textAlign: 'center' }}>Record not found</td></tr>
                                                                                                        )}
                                                                                                    </tbody>
                                                                                                </table>
                                                                                                <div key={item.award_event_profile_id}>{this.renderButtonOrMessage(item)}</div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                );
                                            })}
                                            {awardDetailsList.length > 0 && !isAllCategory ? <>
                                                <div class="orange_strip" style={{
                                                    padding: '11px 15px',
                                                    background: 'rgb(103 178 180)',
                                                    lineHeight: '1',
                                                    color: '#fff',
                                                    fontWeight: '600',
                                                    textAlign: 'left',
                                                    marginBottom: '10px',
                                                    position: 'relative',
                                                }}>Recognition for Extra Ordinary Contribution to the Industry</div>
                                            </> : null}
                                        </div>
                                        {isAllCategory &&
                                            <div className="speaker-button text-lg-center m-0  text-center">
                                                <a
                                                    className="btn my-2"
                                                    onClick={() => this.onAwardApply(null, null)}
                                                >
                                                    See all Awards{" "}
                                                    <i className="fa fa-angle-double-right" />
                                                </a>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </section>
                        </> : <>
                            <section className="pb-5 bg-white">
                                <div className="container">
                                    <h4
                                        className="mb-4 fw-normal text-capitalize"
                                        style={{
                                            fontSize: "26px",
                                            fontFamily: "poppins, serif",
                                            color: "rgb(34, 54, 69)",
                                            lineHeight: 1.22,
                                        }}
                                    >
                                        Awards List
                                    </h4>

                                    <div className="table-responsive shadow-sm rounded">
                                        <table className="table table-bordered align-middle mb-0"
                                            style={{ fontFamily: "poppins, sans-serif" }}
                                        >
                                            <tbody>
                                                {/* Category Header */}
                                                <tr>
                                                    <td colSpan="3"
                                                        className="text-center py-3 text-white fw-bold"
                                                        style={{ backgroundColor: "rgb(103, 178, 180)", fontSize: "15px" }}
                                                    >
                                                        Textile Engineering & Technology Category
                                                    </td>
                                                </tr>

                                                <tr className="fs-6">
                                                    <td className="text-center fw-bold" style={{ width: "60px" }}>1</td>
                                                    <td className="text-center" style={{ width: "80px" }}></td>
                                                    <td>Outstanding Eco Technology Award for Textile Engineering</td>
                                                </tr>
                                                <tr className="fs-6">
                                                    <td className="text-center fw-bold" style={{ width: "60px" }}>2</td>
                                                    <td className="text-center" style={{ width: "80px" }}></td>
                                                    <td>Most Successful "Make in India" Manufacturing Initiative</td>
                                                </tr>
                                                <tr className="fs-6">
                                                    <td className="text-center fw-bold" style={{ width: "60px" }}>3</td>
                                                    <td className="text-center" style={{ width: "80px" }}></td>
                                                    <td>Solution Oriented Indigenous Innovation in Textile Engineering Technology</td>
                                                </tr>
                                                <tr className="fs-6">
                                                    <td className="text-center fw-bold" style={{ width: "60px" }}>4</td>
                                                    <td className="text-center" style={{ width: "80px" }}></td>
                                                    <td>AI Powered Textile Innovation</td>
                                                </tr>

                                                <tr>
                                                    <td colSpan="3"
                                                        className="text-center py-3 text-white fw-bold"
                                                        style={{ backgroundColor: "rgb(103, 178, 180)", fontSize: "15px" }}
                                                    >
                                                        Textile Machinery Spare Parts & Accessories Manufacturer
                                                    </td>
                                                </tr>
                                                
                                                <tr className="fs-6">
                                                    <td className="text-center fw-bold">5</td>
                                                    <td></td>
                                                    <td>Best Reliable Supply Chain Partner</td>
                                                </tr>
                                                {/* Students Category */}
                                                <tr>
                                                    <td colSpan="3"
                                                        className="text-center py-3 text-white fw-bold"
                                                        style={{ backgroundColor: "rgb(103, 178, 180)", fontSize: "15px" }}
                                                    >
                                                        Students & Researchers Category
                                                    </td>
                                                </tr>

                                                <tr className="fs-6">
                                                    <td className="text-center fw-bold">6</td>
                                                    <td></td>
                                                    <td>Prominent Young Researcher of the Year 2026</td>
                                                </tr>


                                                {/* Women Category */}
                                                <tr>
                                                    <td colSpan="3"
                                                        className="text-center py-3 text-white fw-bold"
                                                        style={{ backgroundColor: "rgb(103, 178, 180)", fontSize: "15px" }}
                                                    >
                                                        Legacy
                                                    </td>
                                                </tr>

                                                <tr className="fs-6">
                                                    <td rowSpan="2" className="text-center fw-bold">7</td>
                                                    <td className="text-center">7.1</td>
                                                    <td>Impactful Contribution to Textile Engineering Industry</td>
                                                </tr>
                                                

                                                {/* CTA */}
                                                {/* <tr>
                                                    <td colSpan="3" className="text-center py-4 border-0">
                                                        <a
                                                            href="https://awards.india-itme.com/#/category"
                                                            target="_blank"
                                                            rel="noreferrer"
                                                            className="text-decoration-none"
                                                        >
                                                            <button
                                                                type="button"
                                                                className="btn fw-bold px-5 py-2 text-uppercase rounded-pill shadow-sm"
                                                                style={{
                                                                    border: "1px solid rgb(41, 145, 129)",
                                                                    color: "rgb(41, 145, 129)",
                                                                    backgroundColor: "transparent",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                Apply Now
                                                            </button>
                                                        </a>
                                                    </td>
                                                </tr> */}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </section>

                        </>}
                        <br />
                    </div>
                </>
                <Modal show={this.state.isOpen2} size="lg" >
                    <Modal.Body className="pb-2 pt-2"
                        style={{
                            backgroundImage: 'url("../static/images/login-page-bg.jpg")',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                        }}
                    >
                        <span
                            className="pop-close"
                            onClick={() => this.setState({ isOpen2: false }, () => {
                                const { intervalId } = this.state;
                                if (intervalId) {
                                    clearInterval(intervalId); // Stop the timer
                                    this.setState({ intervalId: null }); // Reset the interval ID
                                }
                            })}
                        >
                            X
                        </span>
                        <div className="container text-center p-4">
                            <img
                                src="../static/images/pop-logo.png"
                                alt="logo"
                                className="image timer-pop"
                            />
                            <h2 className="py-5 text-center com-soon-tag">Coming Soon</h2>
                            <h5 className="timer-pop-text com-soon">
                                The registration will start on {LaunchDate && this.formatDate(LaunchDate)}
                            </h5>
                            <h5 className="pt-3  timer-pop-text com-soon">
                                The registration will be on first come first basis.
                            </h5>
                            <div className="countdown-out mt-5">
                                <div class="countdown">
                                    <div>
                                        <span id="days">{timeLeft.days}</span>
                                        <small>Days</small>
                                    </div>
                                    <div>
                                        <span id="hours">{timeLeft.hours}</span>
                                        <small>Hours</small>
                                    </div>
                                    <div>
                                        <span id="minutes">{timeLeft.minutes}</span>
                                        <small>Minutes</small>
                                    </div>
                                    <div>
                                        <span id="seconds">{timeLeft.seconds}</span>
                                        <small>Seconds</small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <StaticFooter footerData={cmsFooterData} />
                <ToastContainer />
            </>
        )
    }
}
export default withRouter(
    connect(null, { getCurrentAwardDetails_action, getCmsContent_action })(Category)
);
